import { render, staticRenderFns } from "./OPDiagnosisReport.vue?vue&type=template&id=f4e4a946&"
import script from "./OPDiagnosisReport.vue?vue&type=script&lang=js&"
export * from "./OPDiagnosisReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports